import { type GetBestOffersResponse } from './best-offers'

export const getBestOffersMock: GetBestOffersResponse = [
  {
    id: 1086288,
    link: {
      type: 'internal',
      name: 'product',
      pattern: '/:locale/p/:slugV2/:uuid',
      params: {
        id: '152447',
        slug: 'tested-and-certified-used-iphone-12-pro-128-gb-pacific-blue-unlocked',
        slugV2: 'iphone-12-pro-128-gb-pacific-blue-unlocked',
        uuid: 'a88d8ee0-4955-4565-98bb-f46465253890',
        locale: 'en-us',
      },
      query: {},
      hash: { l: '12' },
      href: 'https://www.backmarket.com/en-us/p/iphone-12-pro-128-gb-pacific-blue-unlocked/a88d8ee0-4955-4565-98bb-f46465253890#l=12',
    },
    paymentMethods: [
      {
        bmCode: 'card',
        pspCode: 'adyen_marketpay',
        countryCode: 'US',
        currency: 'USD',
        brandCode: 'card',
        group: 'card',
        networks: ['visa', 'mastercard', 'discover', 'amex'],
        promoCodeEnabled: true,
        hppEnabled: false,
        autoCaptureEnabled: false,
        fraudCheckPartner: 'signifyd',
        enabled: true,
        needMerchantAgreement: false,
        errors: [],
        reference: '8659a80e-5780-46bd-b7b3-e41859b6a0e2',
        integrationType: null,
        config: {},
        architecture: 'legacy',
      },
      {
        bmCode: 'card',
        pspCode: 'processout',
        countryCode: 'US',
        currency: 'USD',
        brandCode: 'card',
        group: 'card',
        networks: ['visa', 'mastercard', 'discover', 'amex'],
        promoCodeEnabled: true,
        hppEnabled: false,
        autoCaptureEnabled: false,
        fraudCheckPartner: 'signifyd',
        enabled: true,
        needMerchantAgreement: false,
        errors: [],
        reference: 'e02e4b57-0595-4c57-9e48-ce463bdfc1cf',
        integrationType: 'native',
        config: { publicKey: 'proj_4EA5pp1QeGOeW8r201pO0vXtUYV1Pd3n' },
        architecture: 'finpay',
      },
      {
        bmCode: 'affirm',
        pspCode: 'adyen_marketpay',
        countryCode: 'US',
        currency: 'USD',
        brandCode: 'affirm',
        group: 'affirm',
        networks: ['affirm'],
        promoCodeEnabled: true,
        hppEnabled: true,
        autoCaptureEnabled: false,
        fraudCheckPartner: '',
        enabled: true,
        needMerchantAgreement: false,
        errors: [],
        reference: 'ac791d7c-54d6-491f-b129-5aa16fe51e34',
        integrationType: 'adyen_checkout_api',
        config: {},
        architecture: 'legacy',
      },
      {
        bmCode: 'affirm',
        pspCode: 'adyen',
        countryCode: 'US',
        currency: 'USD',
        brandCode: 'affirm',
        group: 'affirm',
        networks: ['affirm'],
        promoCodeEnabled: true,
        hppEnabled: false,
        autoCaptureEnabled: false,
        fraudCheckPartner: '',
        enabled: true,
        needMerchantAgreement: false,
        errors: [],
        reference: 'd272d0ac-1303-400c-9797-98ad5d326cae',
        integrationType: null,
        config: {},
        architecture: 'finpay',
      },
      {
        bmCode: 'paypal',
        pspCode: 'paypal',
        countryCode: 'US',
        currency: 'USD',
        brandCode: 'paypal',
        group: 'paypal',
        networks: ['paypal'],
        promoCodeEnabled: false,
        hppEnabled: true,
        autoCaptureEnabled: true,
        fraudCheckPartner: '',
        enabled: false,
        needMerchantAgreement: false,
        errors: ['merchant_not_valid'],
        reference: 'cc412f73-557b-4ac6-ac1d-e0f731ac0186',
        integrationType: null,
        config: {
          publicKey: 'proj_4EA5pp1QeGOeW8r201pO0vXtUYV1Pd3n',
          paypalClientId:
            'ASMYQIKYRutRyLd0JoZ2E6PZRHKa66j-oUH9fy34daFlUH6Tw62m6VI6rZsPalGFOyQTJ-erAYEiO0u-',
        },
        architecture: 'legacy',
      },
      {
        bmCode: 'paypal',
        pspCode: 'processout',
        countryCode: 'US',
        currency: 'USD',
        brandCode: 'paypal_processout',
        group: 'paypal',
        networks: ['paypal'],
        promoCodeEnabled: true,
        hppEnabled: true,
        autoCaptureEnabled: false,
        fraudCheckPartner: '',
        enabled: true,
        needMerchantAgreement: false,
        errors: [],
        reference: '260b68e7-787b-498c-b3b0-0956a839b4c2',
        integrationType: 'hpp',
        config: {
          publicKey: 'proj_4EA5pp1QeGOeW8r201pO0vXtUYV1Pd3n',
          paypalClientId:
            'ASMYQIKYRutRyLd0JoZ2E6PZRHKa66j-oUH9fy34daFlUH6Tw62m6VI6rZsPalGFOyQTJ-erAYEiO0u-',
        },
        architecture: 'finpay',
      },
      {
        bmCode: 'apple_pay',
        pspCode: 'adyen_marketpay',
        countryCode: 'US',
        currency: 'USD',
        brandCode: 'applepay',
        group: 'apple_pay',
        networks: ['apple_pay'],
        promoCodeEnabled: true,
        hppEnabled: false,
        autoCaptureEnabled: false,
        fraudCheckPartner: 'signifyd',
        enabled: true,
        needMerchantAgreement: false,
        errors: [],
        reference: '3e73cbe7-a355-4336-9018-74a5029d0019',
        integrationType: 'hpp',
        config: {
          supportedNetworks: ['visa', 'mastercard', 'amex', 'discover'],
          merchantIdentifier: 'merchant.com.adyen.backMarket',
          supportedCountries: null,
          merchantCapabilities: ['supports3DS'],
        },
        architecture: 'legacy',
      },
      {
        bmCode: 'apple_pay',
        pspCode: 'adyen',
        countryCode: 'US',
        currency: 'USD',
        brandCode: 'applepay',
        group: 'apple_pay',
        networks: ['apple_pay'],
        promoCodeEnabled: true,
        hppEnabled: false,
        autoCaptureEnabled: false,
        fraudCheckPartner: 'signifyd',
        enabled: true,
        needMerchantAgreement: false,
        errors: [],
        reference: '2ef65b8a-22f1-428d-b193-739e54c7d2bf',
        integrationType: 'hpp',
        config: {
          supportedNetworks: ['visa', 'mastercard', 'amex', 'discover'],
          merchantIdentifier: 'merchant.com.adyen.backMarket',
          supportedCountries: null,
          merchantCapabilities: ['supports3DS'],
        },
        architecture: 'finpay',
      },
    ],
    installmentPaymentAsLowAs: null,
    installmentMonthlyPaymentPlan: {
      annualPercentageRate: 10,
      monthlyPrice: { amount: '38.04', currency: 'USD' },
      numberOfMonths: 12,
    },
    price: { amount: '432.67', currency: 'USD' },
    reassurance: {
      isGoodDeal: false,
      stock: {
        stockForCommonDisplay: 10,
        stockRawValue: 68,
        pressureStockLimit: 20,
      },
      tags: ['1-year seller warranty'],
      discount: {
        price: { amount: '366.33', currency: 'USD' },
        rate: '45%',
        isDisplayed: true,
      },
      shipping: {
        free: {
          delayInHours: 72,
          earliestArrivalDate: '2023-07-24',
          latestArrivalDate: '2023-07-25',
          provider: 'FedEx',
        },
        express: {
          delayInHours: 48,
          earliestArrivalDate: '2023-07-21',
          latestArrivalDate: '2023-07-24',
          provider: 'FedEx - 2Days',
          price: { amount: '30.00', currency: 'USD' },
        },
      },
      defaultWarrantyDelay: '1-year seller warranty',
    },
    fee: null,
    backboxGrade: { name: 'Fair', value: 12 },
    isDisabled: false,
    isSelectedByDefault: true,
    comment: '',
    merchant: {
      id: 'b1cbbf7e-331d-479d-b727-7ccf59460935',
      company: 'Glo Sales',
      country: 'United States',
      countryCode: 'US',
      shippedFrom: 'United States',
      nbOfProductsSold: 9700,
      sellerSinceYear: 2023,
      link: {
        type: 'internal',
        name: 'merchant_landing',
        pattern: '/:locale/s/:merchantName/:uuid',
        params: {
          locale: 'en-us',
          id: '4244',
          shop: 'seller',
          uuid: 'b1cbbf7e-331d-479d-b727-7ccf59460935',
          merchantName: 'glo-sales',
        },
        query: {},
        hash: {},
        href: 'https://www.backmarket.com/en-us/s/glo-sales/b1cbbf7e-331d-479d-b727-7ccf59460935',
      },
      legacyId: 4244,
    },
    eligibleToInstallmentPayment: true,
    eligibleToKlarna: true,
    collection: [],
    skinnyBannerId: null,
    newBattery: {
      status: 'available',
      offerType: '7',
    },
  },
  {
    id: 812557,
    link: {
      type: 'internal',
      name: 'product',
      pattern: '/:locale/p/:slugV2/:uuid',
      params: {
        id: '152447',
        slug: 'tested-and-certified-used-iphone-12-pro-128-gb-pacific-blue-unlocked',
        slugV2: 'iphone-12-pro-128-gb-pacific-blue-unlocked',
        uuid: 'a88d8ee0-4955-4565-98bb-f46465253890',
        locale: 'en-us',
      },
      query: {},
      hash: { l: '11' },
      href: 'https://www.backmarket.com/en-us/p/iphone-12-pro-128-gb-pacific-blue-unlocked/a88d8ee0-4955-4565-98bb-f46465253890#l=11',
    },
    paymentMethods: [
      {
        bmCode: 'card',
        pspCode: 'adyen_marketpay',
        countryCode: 'US',
        currency: 'USD',
        brandCode: 'card',
        group: 'card',
        networks: ['visa', 'mastercard', 'discover', 'amex'],
        promoCodeEnabled: true,
        hppEnabled: false,
        autoCaptureEnabled: false,
        fraudCheckPartner: 'signifyd',
        enabled: true,
        needMerchantAgreement: false,
        errors: [],
        reference: '8659a80e-5780-46bd-b7b3-e41859b6a0e2',
        integrationType: null,
        config: {},
        architecture: 'legacy',
      },
      {
        bmCode: 'card',
        pspCode: 'processout',
        countryCode: 'US',
        currency: 'USD',
        brandCode: 'card',
        group: 'card',
        networks: ['visa', 'mastercard', 'discover', 'amex'],
        promoCodeEnabled: true,
        hppEnabled: false,
        autoCaptureEnabled: false,
        fraudCheckPartner: 'signifyd',
        enabled: true,
        needMerchantAgreement: false,
        errors: [],
        reference: 'e02e4b57-0595-4c57-9e48-ce463bdfc1cf',
        integrationType: 'native',
        config: { publicKey: 'proj_4EA5pp1QeGOeW8r201pO0vXtUYV1Pd3n' },
        architecture: 'finpay',
      },
      {
        bmCode: 'affirm',
        pspCode: 'adyen_marketpay',
        countryCode: 'US',
        currency: 'USD',
        brandCode: 'affirm',
        group: 'affirm',
        networks: ['affirm'],
        promoCodeEnabled: true,
        hppEnabled: true,
        autoCaptureEnabled: false,
        fraudCheckPartner: '',
        enabled: true,
        needMerchantAgreement: false,
        errors: [],
        reference: 'ac791d7c-54d6-491f-b129-5aa16fe51e34',
        integrationType: 'adyen_checkout_api',
        config: {},
        architecture: 'legacy',
      },
      {
        bmCode: 'affirm',
        pspCode: 'adyen',
        countryCode: 'US',
        currency: 'USD',
        brandCode: 'affirm',
        group: 'affirm',
        networks: ['affirm'],
        promoCodeEnabled: true,
        hppEnabled: false,
        autoCaptureEnabled: false,
        fraudCheckPartner: '',
        enabled: true,
        needMerchantAgreement: false,
        errors: [],
        reference: 'd272d0ac-1303-400c-9797-98ad5d326cae',
        integrationType: null,
        config: {},
        architecture: 'finpay',
      },
      {
        bmCode: 'paypal',
        pspCode: 'paypal',
        countryCode: 'US',
        currency: 'USD',
        brandCode: 'paypal',
        group: 'paypal',
        networks: ['paypal'],
        promoCodeEnabled: false,
        hppEnabled: true,
        autoCaptureEnabled: true,
        fraudCheckPartner: '',
        enabled: true,
        needMerchantAgreement: false,
        errors: [],
        reference: 'cc412f73-557b-4ac6-ac1d-e0f731ac0186',
        integrationType: null,
        config: {},
        architecture: 'legacy',
      },
      {
        bmCode: 'paypal',
        pspCode: 'processout',
        countryCode: 'US',
        currency: 'USD',
        brandCode: 'paypal_processout',
        group: 'paypal',
        networks: ['paypal'],
        promoCodeEnabled: true,
        hppEnabled: true,
        autoCaptureEnabled: false,
        fraudCheckPartner: '',
        enabled: true,
        needMerchantAgreement: false,
        errors: [],
        reference: '260b68e7-787b-498c-b3b0-0956a839b4c2',
        integrationType: 'hpp',
        config: {
          publicKey: 'proj_4EA5pp1QeGOeW8r201pO0vXtUYV1Pd3n',
          paypalClientId:
            'ASMYQIKYRutRyLd0JoZ2E6PZRHKa66j-oUH9fy34daFlUH6Tw62m6VI6rZsPalGFOyQTJ-erAYEiO0u-',
        },
        architecture: 'finpay',
      },
      {
        bmCode: 'apple_pay',
        pspCode: 'adyen_marketpay',
        countryCode: 'US',
        currency: 'USD',
        brandCode: 'applepay',
        group: 'apple_pay',
        networks: ['apple_pay'],
        promoCodeEnabled: true,
        hppEnabled: false,
        autoCaptureEnabled: false,
        fraudCheckPartner: 'signifyd',
        enabled: true,
        needMerchantAgreement: false,
        errors: [],
        reference: '3e73cbe7-a355-4336-9018-74a5029d0019',
        integrationType: 'hpp',
        config: {
          supportedNetworks: ['visa', 'mastercard', 'amex', 'discover'],
          merchantIdentifier: 'merchant.com.adyen.backMarket',
          supportedCountries: null,
          merchantCapabilities: ['supports3DS'],
        },
        architecture: 'legacy',
      },
      {
        bmCode: 'apple_pay',
        pspCode: 'adyen',
        countryCode: 'US',
        currency: 'USD',
        brandCode: 'applepay',
        group: 'apple_pay',
        networks: ['apple_pay'],
        promoCodeEnabled: true,
        hppEnabled: false,
        autoCaptureEnabled: false,
        fraudCheckPartner: 'signifyd',
        enabled: true,
        needMerchantAgreement: false,
        errors: [],
        reference: '2ef65b8a-22f1-428d-b193-739e54c7d2bf',
        integrationType: 'hpp',
        config: {
          supportedNetworks: ['visa', 'mastercard', 'amex', 'discover'],
          merchantIdentifier: 'merchant.com.adyen.backMarket',
          supportedCountries: null,
          merchantCapabilities: ['supports3DS'],
        },
        architecture: 'finpay',
      },
    ],
    installmentPaymentAsLowAs: null,
    installmentMonthlyPaymentPlan: {
      annualPercentageRate: 10,
      monthlyPrice: { amount: '45.87', currency: 'USD' },
      numberOfMonths: 12,
    },
    price: { amount: '521.73', currency: 'USD' },
    reassurance: {
      isGoodDeal: false,
      stock: {
        stockForCommonDisplay: 1,
        stockRawValue: 1,
        pressureStockLimit: 20,
      },
      tags: ['1-year seller warranty'],
      discount: {
        price: { amount: '277.27', currency: 'USD' },
        rate: '34%',
        isDisplayed: true,
      },
      shipping: {
        free: {
          delayInHours: 72,
          earliestArrivalDate: '2023-07-24',
          latestArrivalDate: '2023-07-25',
          provider: 'UPS',
        },
        express: {
          delayInHours: 48,
          earliestArrivalDate: '2023-07-21',
          latestArrivalDate: '2023-07-24',
          provider: 'UPS 2nd Day Air',
          price: { amount: '10.00', currency: 'USD' },
        },
      },
      defaultWarrantyDelay: '1-year seller warranty',
    },
    fee: null,
    backboxGrade: { name: 'Good', value: 11 },
    isDisabled: false,
    isSelectedByDefault: false,
    comment: '',
    merchant: {
      id: 'dbefff6b-b1f4-4e4b-a0ee-ff8938dc3e04',
      company: 'Decluttr',
      country: 'United States',
      countryCode: 'US',
      shippedFrom: 'United States',
      nbOfProductsSold: 9900,
      sellerSinceYear: 2022,
      link: {
        type: 'internal',
        name: 'merchant_landing',
        pattern: '/:locale/s/:merchantName/:uuid',
        params: {
          locale: 'en-us',
          id: '3200',
          shop: 'seller',
          uuid: 'dbefff6b-b1f4-4e4b-a0ee-ff8938dc3e04',
          merchantName: 'decluttr',
        },
        query: {},
        hash: {},
        href: 'https://www.backmarket.com/en-us/s/decluttr/dbefff6b-b1f4-4e4b-a0ee-ff8938dc3e04',
      },
      legacyId: 3200,
    },
    eligibleToInstallmentPayment: true,
    eligibleToKlarna: true,
    collection: [],
    skinnyBannerId: null,
    newBattery: {
      status: 'disabled',
    },
  },
  {
    id: 1077123,
    link: {
      type: 'internal',
      name: 'product',
      pattern: '/:locale/p/:slugV2/:uuid',
      params: {
        id: '152447',
        slug: 'tested-and-certified-used-iphone-12-pro-128-gb-pacific-blue-unlocked',
        slugV2: 'iphone-12-pro-128-gb-pacific-blue-unlocked',
        uuid: 'a88d8ee0-4955-4565-98bb-f46465253890',
        locale: 'en-us',
      },
      query: {},
      hash: { l: '10' },
      href: 'https://www.backmarket.com/en-us/p/iphone-12-pro-128-gb-pacific-blue-unlocked/a88d8ee0-4955-4565-98bb-f46465253890#l=10',
    },
    paymentMethods: [
      {
        bmCode: 'card',
        pspCode: 'adyen_marketpay',
        countryCode: 'US',
        currency: 'USD',
        brandCode: 'card',
        group: 'card',
        networks: ['visa', 'mastercard', 'discover', 'amex'],
        promoCodeEnabled: true,
        hppEnabled: false,
        autoCaptureEnabled: false,
        fraudCheckPartner: 'signifyd',
        enabled: true,
        needMerchantAgreement: false,
        errors: [],
        reference: '8659a80e-5780-46bd-b7b3-e41859b6a0e2',
        integrationType: null,
        config: {},
        architecture: 'legacy',
      },
      {
        bmCode: 'card',
        pspCode: 'processout',
        countryCode: 'US',
        currency: 'USD',
        brandCode: 'card',
        group: 'card',
        networks: ['visa', 'mastercard', 'discover', 'amex'],
        promoCodeEnabled: true,
        hppEnabled: false,
        autoCaptureEnabled: false,
        fraudCheckPartner: 'signifyd',
        enabled: true,
        needMerchantAgreement: false,
        errors: [],
        reference: 'e02e4b57-0595-4c57-9e48-ce463bdfc1cf',
        integrationType: 'native',
        config: { publicKey: 'proj_4EA5pp1QeGOeW8r201pO0vXtUYV1Pd3n' },
        architecture: 'finpay',
      },
      {
        bmCode: 'affirm',
        pspCode: 'adyen_marketpay',
        countryCode: 'US',
        currency: 'USD',
        brandCode: 'affirm',
        group: 'affirm',
        networks: ['affirm'],
        promoCodeEnabled: true,
        hppEnabled: true,
        autoCaptureEnabled: false,
        fraudCheckPartner: '',
        enabled: true,
        needMerchantAgreement: false,
        errors: [],
        reference: 'ac791d7c-54d6-491f-b129-5aa16fe51e34',
        integrationType: 'adyen_checkout_api',
        config: {},
        architecture: 'legacy',
      },
      {
        bmCode: 'affirm',
        pspCode: 'adyen',
        countryCode: 'US',
        currency: 'USD',
        brandCode: 'affirm',
        group: 'affirm',
        networks: ['affirm'],
        promoCodeEnabled: true,
        hppEnabled: false,
        autoCaptureEnabled: false,
        fraudCheckPartner: '',
        enabled: true,
        needMerchantAgreement: false,
        errors: [],
        reference: 'd272d0ac-1303-400c-9797-98ad5d326cae',
        integrationType: null,
        config: {},
        architecture: 'finpay',
      },
      {
        bmCode: 'paypal',
        pspCode: 'paypal',
        countryCode: 'US',
        currency: 'USD',
        brandCode: 'paypal',
        group: 'paypal',
        networks: ['paypal'],
        promoCodeEnabled: false,
        hppEnabled: true,
        autoCaptureEnabled: true,
        fraudCheckPartner: '',
        enabled: false,
        needMerchantAgreement: false,
        errors: ['merchant_not_valid'],
        reference: 'cc412f73-557b-4ac6-ac1d-e0f731ac0186',
        integrationType: null,
        config: {},
        architecture: 'legacy',
      },
      {
        bmCode: 'paypal',
        pspCode: 'processout',
        countryCode: 'US',
        currency: 'USD',
        brandCode: 'paypal_processout',
        group: 'paypal',
        networks: ['paypal'],
        promoCodeEnabled: true,
        hppEnabled: true,
        autoCaptureEnabled: false,
        fraudCheckPartner: '',
        enabled: true,
        needMerchantAgreement: false,
        errors: [],
        reference: '260b68e7-787b-498c-b3b0-0956a839b4c2',
        integrationType: 'hpp',
        config: {
          publicKey: 'proj_4EA5pp1QeGOeW8r201pO0vXtUYV1Pd3n',
          paypalClientId:
            'ASMYQIKYRutRyLd0JoZ2E6PZRHKa66j-oUH9fy34daFlUH6Tw62m6VI6rZsPalGFOyQTJ-erAYEiO0u-',
        },
        architecture: 'finpay',
      },
      {
        bmCode: 'apple_pay',
        pspCode: 'adyen_marketpay',
        countryCode: 'US',
        currency: 'USD',
        brandCode: 'applepay',
        group: 'apple_pay',
        networks: ['apple_pay'],
        promoCodeEnabled: true,
        hppEnabled: false,
        autoCaptureEnabled: false,
        fraudCheckPartner: 'signifyd',
        enabled: true,
        needMerchantAgreement: false,
        errors: [],
        reference: '3e73cbe7-a355-4336-9018-74a5029d0019',
        integrationType: 'hpp',
        config: {
          supportedNetworks: ['visa', 'mastercard', 'amex', 'discover'],
          merchantIdentifier: 'merchant.com.adyen.backMarket',
          supportedCountries: null,
          merchantCapabilities: ['supports3DS'],
        },
        architecture: 'legacy',
      },
      {
        bmCode: 'apple_pay',
        pspCode: 'adyen',
        countryCode: 'US',
        currency: 'USD',
        brandCode: 'applepay',
        group: 'apple_pay',
        networks: ['apple_pay'],
        promoCodeEnabled: true,
        hppEnabled: false,
        autoCaptureEnabled: false,
        fraudCheckPartner: 'signifyd',
        enabled: true,
        needMerchantAgreement: false,
        errors: [],
        reference: '2ef65b8a-22f1-428d-b193-739e54c7d2bf',
        integrationType: 'hpp',
        config: {
          supportedNetworks: ['visa', 'mastercard', 'amex', 'discover'],
          merchantIdentifier: 'merchant.com.adyen.backMarket',
          supportedCountries: null,
          merchantCapabilities: ['supports3DS'],
        },
        architecture: 'finpay',
      },
    ],
    installmentPaymentAsLowAs: null,
    installmentMonthlyPaymentPlan: {
      annualPercentageRate: 10,
      monthlyPrice: { amount: '39.56', currency: 'USD' },
      numberOfMonths: 12,
    },
    price: { amount: '450.00', currency: 'USD' },
    reassurance: {
      isGoodDeal: true,
      stock: {
        stockForCommonDisplay: 10,
        stockRawValue: 20,
        pressureStockLimit: 20,
      },
      tags: ['1-year seller warranty'],
      discount: {
        price: { amount: '349.00', currency: 'USD' },
        rate: '43%',
        isDisplayed: true,
      },
      shipping: {
        free: {
          delayInHours: 72,
          earliestArrivalDate: '2023-07-24',
          latestArrivalDate: '2023-07-25',
          provider: 'FedEx',
        },
        express: {
          delayInHours: 48,
          earliestArrivalDate: '2023-07-21',
          latestArrivalDate: '2023-07-24',
          provider: 'FedEx - 2Days',
          price: { amount: '30.00', currency: 'USD' },
        },
      },
      defaultWarrantyDelay: '1-year seller warranty',
    },
    fee: null,
    backboxGrade: { name: 'Excellent', value: 10 },
    isDisabled: false,
    isSelectedByDefault: false,
    comment: '',
    merchant: {
      id: 'b1cbbf7e-331d-479d-b727-7ccf59460935',
      company: 'Glo Sales',
      country: 'United States',
      countryCode: 'US',
      shippedFrom: 'United States',
      nbOfProductsSold: 9700,
      sellerSinceYear: 2023,
      link: {
        type: 'internal',
        name: 'merchant_landing',
        pattern: '/:locale/s/:merchantName/:uuid',
        params: {
          locale: 'en-us',
          id: '4244',
          shop: 'seller',
          uuid: 'b1cbbf7e-331d-479d-b727-7ccf59460935',
          merchantName: 'glo-sales',
        },
        query: {},
        hash: {},
        href: 'https://www.backmarket.com/en-us/s/glo-sales/b1cbbf7e-331d-479d-b727-7ccf59460935',
      },
      legacyId: 4244,
    },
    eligibleToInstallmentPayment: true,
    eligibleToKlarna: true,
    collection: [],
    skinnyBannerId: null,
    newBattery: {
      status: 'not-available',
    },
  },
]
